import { ItemChartModel } from '../global/item-chart.model';

export class QuotationChartModel {
  total: number = 0;
  states: ItemChartModel[] = [];
  types: ItemChartModel[] = [];
}
